export function buildPlotStatusCql (showInsured, showUninsured) {
  const insuredFilter = "(bs = 1 OR bs = 1.0 OR bs = '1' OR bs = '1.0' OR bs = '1.00')"
  const uninsuredFilter = "(bs IS NULL OR bs = 0 OR bs = 0.0 OR bs = '' OR bs = '0' OR bs = '0.0' OR bs = '0.00')"

  if (showInsured && showUninsured) {
    return `(${insuredFilter} OR ${uninsuredFilter})`
  }

  if (showInsured) {
    return insuredFilter
  }

  if (showUninsured) {
    return uninsuredFilter
  }

  return '1=0'
}
